import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=642c416e&scoped=true"
import script from "./addProduct.vue?vue&type=script&lang=js"
export * from "./addProduct.vue?vue&type=script&lang=js"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=642c416e&prod&lang=stylus&scoped=true"
import style1 from "./addProduct.vue?vue&type=style&index=1&id=642c416e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c416e",
  null
  
)

export default component.exports